import { useState } from "react";

import "./ProposalModal.css";
import listCountries from "../../utils/listCountries";

function ProposalModal({ isOpen, onClose, selectedCourse }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) {
    return null;
  }

  const courseTitle = selectedCourse?.post_title || selectedCourse?.title || "";

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      fullName: e.target.fullName.value,
      companyName: e.target.companyName.value,
      phone: e.target.phone.value,
      email: e.target.email.value,
      address: e.target.address.value,
      country: e.target.country.value,
      subject: e.target.subject.value,
      message: e.target.message.value,
      courseTitle,
    };

    try {
      setIsSubmitting(true);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/proposal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to send request");
      }

      alert("Your training proposal request has been sent.");
      onClose();
    } catch (error) {
      console.error(error);
      alert("Failed to send request. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="proposal-modal-overlay">
      <div className="proposal-modal">
        <button type="button" className="proposal-close" onClick={onClose}>
          ×
        </button>

        <div className="proposal-header">
          <h2>Request Training Proposal</h2>
          <p>
            Send us your training requirements and our team will prepare a
            proposal for your organization.
          </p>
        </div>

        <form className="proposal-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label>Full Name <span>*</span></label>
            <input name="fullName" placeholder="Full Name" required />
          </div>
          <div className="form-row">
            <label>Company Name <span>*</span></label>
            <input name="companyName" placeholder="Company Name" required />
          </div>
          <div className="form-row">
            <label>Phone Number <span>*</span></label>
            <input name="phone" placeholder="Phone Number" required />
          </div>
          <div className="form-row">
            <label>Email <span>*</span></label>
            <input name="email" type="email" placeholder="Email" required />
          </div>
          <div className="form-row">
            <label>Address</label>
            <input name="address" placeholder="Address" />
          </div>
          <div className="form-row">
            <label>Country <span>*</span></label>
            <select name="country" required defaultValue="">
              <option value="" disabled>Select Country</option>
              {listCountries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </select>
          </div>
          <div className="form-row">
            <label>Subject</label>
            <input
              name="subject"
              placeholder="Subject"
              defaultValue={courseTitle ? `Training Proposal Request - ${courseTitle}` : "Training Proposal Request"}
            />
          </div>
          <div className="form-row">
            <label>Your Message</label>
            <textarea
              name="message"
              rows="5"
              placeholder="Inquiry Message"
              defaultValue={courseTitle ? `I would like to request a training proposal for ${courseTitle}.` : ""}
            />
          </div>
          <button type="submit" className="proposal-submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Send Request"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ProposalModal;
